import AccordionCard from "../shared/AccordionCard";

interface QualityCardProps {
  light: string;
  lowLight: string;
  blurFrames: string;
  blackouts: string;
  // pass: string;
}

function QualityCard({
  light,
  // lowLight,
  blurFrames,
  blackouts,
  // pass,
}: QualityCardProps) {
  const items = [
    { label: "Light", value: light },
    // { label: "Low light", value: lowLight },
    { label: "Blur frames", value: blurFrames },
    { label: "Blackouts", value: blackouts },
    // { label: "Pass", value: pass },
  ];

  return (
    <AccordionCard title="QUALITY">
      <div className="metric-grid">
        {items.map((item) => (
          <div key={item.label} className="metric-tile">
            <span className="metric-tile__label">
              {item.label}
            </span>

            <strong className="metric-tile__value">
              {item.value}
            </strong>
          </div>
        ))}
      </div>
    </AccordionCard>
  );
}

export default QualityCard;